import { Button, Grid, IconButton, List, ListItem, ListItemText, TextField, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import React, { useState } from "react";
import { useTranslation } from 'react-i18next';

const DomainListField = ({domains, addDomain, removeDomain}) => {
    const { t } = useTranslation();
    const [newDomain, setNewDomain] = useState("");

    return (
        <>
            <Typography sx={{ fontWeight: 700 }}>{t('settings.authorizedDomains')}</Typography>
            <Typography variant="body2" sx={{ color: (theme) => theme.custom.muted, mb: 1 }}>
                {t('settings.domainsHelp')}
            </Typography>
            <Grid container spacing={2} mt={1}>
                <Grid item md={12}>
                    <List sx={{ border: (theme) => `1px solid ${theme.custom.border}`, borderRadius: '5px' }}>
                        {domains.map((domain, key) => (
                            <ListItem
                                key={key}
                                sx={key===0 ? {} : { borderTop: (theme) => `1px solid ${theme.custom.border}` }}
                                secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => {
                                        removeDomain(key);
                                    }}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                }>
                                <ListItemText primary={domain} />
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            </Grid>
            <Grid container spacing={2} mt={1}>
                <Grid item md={10}>
                    <TextField label={t('settings.domainPlaceholder')} variant="outlined" fullWidth onChange={e => setNewDomain(e.target.value)} value={newDomain} />
                </Grid>
                <Grid item md={2} alignItems={"stretch"} style={{display: "flex"}} justifyContent="right">
                    <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => {
                        // domain cannot be empty
                        const regex = /^\s*$/;
                        if(!regex.test(newDomain)){
                            addDomain(newDomain);
                            setNewDomain("");
                        }
                    }}>{t('settings.addDomain')}</Button>
                </Grid>
            </Grid>
        </>

    )
}

export default DomainListField;
